<form [formGroup]="createBatchForm">
 <div class="invite-dialog">
  <button mat-icon-button class="close-btn" (click)="close()">
    <mat-icon>close</mat-icon>
  </button>

  <h2>Create New Batch</h2>
  <p class="subtitle">
    Create a new batch for organizing students by year and department
  </p>

  <div class="form-group full-width">
    <label class="field-label">Batch Name *</label>
    <mat-form-field appearance="outline" class="full-width">
      <input matInput formControlName="batch_name" placeholder="e.g., A, B, C" />
    </mat-form-field>
	<small *ngIf="createBatchForm.controls['batch_name'].invalid && createBatchForm.controls['batch_name'].touched"
	class="text-danger smaller-text">Batch name is required</small>			
  </div>

  <div class="year-row">
    <div class="form-group half-width">
      <label class="field-label">Academic Year From *</label>
      <mat-form-field appearance="outline" class="half-width">
        <mat-select formControlName="academic_year_from">
			    <mat-option disabled value="">From</mat-option>
          <mat-option *ngFor="let y of years" [value]="y">{{ y }}</mat-option>
        </mat-select>
      </mat-form-field>

    </div>

    <div class="form-group half-width">
      <label class="field-label">Academic Year To *</label>
      <mat-form-field appearance="outline" class="half-width">
        <mat-select formControlName="academic_year_to">
		<mat-option disabled value="">To</mat-option>
          <mat-option *ngFor="let y of years" [value]="y">{{ y }}</mat-option>
        </mat-select>
      </mat-form-field>
    </div>
  </div>

  <div class="form-group full-width">
    <label class="field-label">Department *</label>
    <mat-form-field appearance="outline" class="full-width">
      <mat-select formControlName="department_id" (openedChange)="onOpen($event)" placeholder="select department"
	    (selectionChange)="onDepartmentChange($event.value)">

        <div class="select-search-container">
          <mat-form-field appearance="outline" class="search-field">
            <mat-icon matPrefix>search</mat-icon>
            <input matInput placeholder="Search..." formControlName="searchText" (input)="filterDepartments()" />
          </mat-form-field>
        </div>

        <mat-option *ngFor="let department of filteredDepartments" [value]="department.id.toString()">
          {{ department.name }}
        </mat-option>
		      <mat-option value="other">Other</mat-option>

      </mat-select>
    </mat-form-field>
  </div>

<div class="form-group full-width" *ngIf="showOtherDepartmentField">
  <label class="field-label">Enter Department Name</label>
  <mat-form-field appearance="outline" class="full-width">
    <input
      matInput
      placeholder="Enter department name..."
      formControlName="department_name"
      #otherDeptInput
    />
  </mat-form-field>
</div>

  <div class="actions">
    <button mat-stroked-button (click)="close()">Cancel</button>
    <button mat-flat-button color="primary" class="dark-blue" (click)="postCreateBatch()" 
	[disabled]="isLoading">
	<ng-container *ngIf="isLoading; else noLoading">
    <span class="spinner-border spinner-border-sm"></span>  Creating...</ng-container>
	<ng-template #noLoading>
      Create Batch</ng-template>
    </button>
  </div>
</div>
</form>